<template>
  <!-- DaisyUI popover-API dropdown: stays open while a native <select> popup takes focus, and closes on outside click / Esc natively. -->
  <div class="inline-block">
    <button
      type="button"
      :class="buttonClass"
      :title="title"
      :aria-label="title"
      :disabled="disabled"
      :popovertarget="id"
      :style="`anchor-name: ${anchor}`"
    >
      <slot name="trigger" />
    </button>
    <component
      :is="as"
      ref="popoverRef"
      :id="id"
      popover
      class="dropdown dropdown-end"
      :class="contentClass"
      :style="`position-anchor: ${anchor}`"
    >
      <slot :close="close" />
    </component>
  </div>
</template>

<script setup>
import { ref, useId, defineProps, defineExpose } from "vue";

defineProps({
  buttonClass: { type: String, default: "btn" },
  contentClass: {
    type: String,
    default: "menu bg-base-100 rounded-box w-52 p-2 shadow-lg mt-1",
  },
  title: { type: String, default: undefined },
  disabled: { type: Boolean, default: false },
  as: { type: String, default: "ul" },
});

const id = useId();
const anchor = `--${id}`;
const popoverRef = ref(null);

function close() {
  popoverRef.value?.hidePopover();
}

defineExpose({ close });
</script>
